import type { GTMBrochureDownloadEvent } from "../types/types";

/**
 * Initialize the dataLayer array if it doesn't exist
 * GTM script should create this, but we initialize as fallback
 */
export function initializeDataLayer(): void {
  if (typeof window === "undefined") {
    console.warn("Window not available (SSR?), cannot initialize dataLayer");
    return;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
    console.warn("GTM dataLayer not found, initialized empty array");
  }
}

/**
 * Check if GTM is loaded and dataLayer exists
 * @returns true if window.dataLayer is available
 */
export function isGTMLoaded(): boolean {
  return typeof window !== "undefined" && Array.isArray(window.dataLayer);
}

/**
 * Push an event to the GTM dataLayer with type safety
 * @param event - The GTM event object to push
 */
export function pushToDataLayer(event: GTMBrochureDownloadEvent): void {
  // Safety check: ensure we're in browser environment
  if (typeof window === "undefined") {
    console.warn("Window not available, skipping GTM push");
    return;
  }

  // Initialize dataLayer if not present (GTM blocked or failed to load)
  if (!window.dataLayer) {
    console.warn("GTM dataLayer not initialized, initializing now");
    initializeDataLayer();
  }

  // Push event to dataLayer
  try {
    window.dataLayer.push(event);
    console.log("GTM event pushed:", event.event, event);
  } catch (error) {
    console.error("Error pushing to dataLayer:", error);
  }
}
